/* Swiper Configuration */
const swiperMovies = new Swiper('.swiper.swiper-movies', {
    direction: "horizontal",
    pagination: {
        el: ".swiper-pagination",
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    spaceBetween: 30,
    slidesPerView: 1,

    breakpoints: {
        576: {
            slidesPerView: 2,
        }, 
        768: {
            slidesPerView: 3,
        },
        990: {
            slidesPerView: 4
        }
    }
})